// R115 calendar hub — OPS layers: inspections + tasks (day chips), health (row
// badges) and guest_signals (stay decoration, client-only from the base payload).
// Data comes from the server providers server/calendarLayers/{inspections,tasks,health}.js.
import { registerLayer, type ChipSpec, type BadgeSpec, type StayDecoration } from '../registry';
import { inspChips, taskChip, healthBadges, staySignals, isGhost } from '../../../../../lib/calendarOps.mjs';
import { OFFICE, insp, tasks, health, jobsBy, tasksBy } from './util';

registerLayer({
  id: 'inspections', label: 'Inspections', swatch: 'var(--info)', scope: 'day', server: 'inspections', roles: OFFICE,
  chips: (p, ctx) => {
    const L = insp(ctx);
    if (!L) return [];
    return (jobsBy(L).get(p.listing_id) || []).flatMap(j => inspChips(j, ctx.asOf, ctx.from, ctx.to)) as ChipSpec[];
  },
  count: (ctx) => {
    const L = insp(ctx);
    if (!L) return null;
    return L.jobs.filter(j => !isGhost(j) && ((j.date >= ctx.from && j.date <= ctx.to) || (!!j.roll_to && j.roll_to >= ctx.from && j.roll_to <= ctx.to))).length;
  },
});

registerLayer({
  id: 'tasks', label: 'Tasks', swatch: 'var(--accent-fill)', scope: 'day', server: 'tasks', roles: OFFICE,
  chips: (p, ctx) => {
    const L = tasks(ctx);
    if (!L) return [];
    return (tasksBy(L).get(p.listing_id) || []).map(t => taskChip(t, ctx.asOf)).filter(Boolean) as ChipSpec[];
  },
  count: (ctx) => { const L = tasks(ctx); return L ? L.items.length : null; },
});

registerLayer({
  id: 'health', label: 'Home health', swatch: 'var(--warning)', scope: 'row', server: 'health', roles: OFFICE,
  badges: (p, ctx) => {
    const L = health(ctx);
    return L ? (healthBadges(L.by_listing[p.listing_id], p.listing_id) as BadgeSpec[]) : [];
  },
  count: (ctx) => {
    const L = health(ctx);
    if (!L) return null;
    return ctx.data.properties.filter(p => { const r = L.by_listing[p.listing_id]; return !!(r && (r.open_issues || r.supply_open)); }).length;
  },
});

registerLayer({
  id: 'guest_signals', label: 'Guest signals', swatch: 'var(--danger)', scope: 'stay', roles: OFFICE,
  decorateStay: (s, ctx) => staySignals(s, ctx.asOf) as StayDecoration | null,
  count: (ctx) => ctx.data.stays.filter(s => !!staySignals(s, ctx.asOf)).length,
});
